<section class="w-10/12 lg:w-11/12 mx-auto py-16 flex flex-wrap">
  <div class="w-full lg:w-1/4 pr-4 mt-1">
    <img
      src="assets/img/Shared/pygmalios-logo-footer.svg"
      alt="Logo"
      class="max-w-none w-48"
    />
    <p class="pt-6 pb-8">{{ "footer.subtitle" | translate }}</p>
    <div class="flex justify-between w-28">
      <a href="https://www.facebook.com/pygmalios" target="_blank">
        <img src="assets/img/Shared/Facebook - Negative.svg" alt="Facebook" />
      </a>
      <a href="https://twitter.com/pygmalios?lang=en" target="_blank">
        <img src="assets/img/Shared/Twitter - Negative.svg" alt="Twitter" />
      </a>
      <a
        href="https://www.linkedin.com/company/pygmalios/?originalSubdomain=en"
        target="_blank"
      >
        <img src="assets/img/Shared/LinkedIn - Negative.svg" alt="LinkedIn" />
      </a>
    </div>
  </div>

  <!-- Solutions Column -->
  <div class="mt-12 lg:mt-0 w-1/2 lg:w-3/16 pr-6">
    <h6>{{ "footer.solutions" | translate }}</h6>
    <ul>
      <li class="py-3">
        <a langRouterLink="solutions">{{ "products_page.products.traffic_analytics" | translate }}</a>
      </li>
      <li class="py-3">
        <a langRouterLink="solutions">{{ "products_page.products.journey_analytics" | translate }}</a>
      </li>
      <li class="py-3">
        <a langRouterLink="solutions">{{ "main_page.dual_pillar.qiq" | translate }}</a>
      </li>
      <li class="py-3">
        <a langRouterLink="innovation">{{ "footer.innovation" | translate }}</a>
      </li>
    </ul>
  </div>

  <!-- Industries Column -->
  <div class="mt-12 lg:mt-0 w-1/2 lg:w-3/16 pr-6">
    <h6>{{ "footer.industries" | translate }}</h6>
    <ul>
      <li class="py-3">
        <a langRouterLink="industries/retail">{{ "industry_page.retail.title" | translate }}</a>
      </li>
      <li class="py-3">
        <a langRouterLink="industries/malls">{{ "industry_page.malls.title" | translate }}</a>
      </li>
      <li class="py-3">
        <a langRouterLink="industries/telecom-banking">{{ "industry_page.telecom_banking.title" | translate }}</a>
      </li>
      <li class="py-3">
        <a langRouterLink="industries/forecourt">{{ "industry_page.forecourt.title" | translate }}</a>
      </li>
    </ul>
  </div>

  <!-- Company Column -->
  <div class="mt-12 lg:mt-0 w-1/2 lg:w-3/16 pr-6">
    <h6>{{ "footer.company" | translate }}</h6>
    <ul>
      <li class="py-3">
        <a langRouterLink="about">{{ "footer.about" | translate }}</a>
      </li>
      <li class="py-3">
        <a langRouterLink="case-studies">{{ "footer.case_studies" | translate }}</a>
      </li>
      <li class="py-3">
        <a langRouterLink="platform">{{ "footer.platform" | translate }}</a>
      </li>
      <li class="py-3">
        <a langRouterLink="blog">{{ "footer.blog" | translate }}</a>
      </li>
      <li class="py-3">
        <a langRouterLink="privacy-policy">{{ "footer.privacy_policy" | translate }}</a>
      </li>
    </ul>
  </div>

  <!-- Contact Column -->
  <div class="mt-12 lg:mt-0 w-1/2 lg:w-3/16">
    <h6>{{ "footer.contact" | translate }}</h6>
    <ul>
      <li class="py-3">
        <a langRouterLink="contact_us" class="pygCta">{{ "footer.contact" | translate }}</a>
      </li>
      <li class="py-3">
        <a [attr.href]="'mailto:' + email()" target="_blank">{{ email() }}</a>
      </li>
      <li class="py-3 pygColor">
        <a [attr.href]="'tel:' + tel()">{{ tel() }}</a>
      </li>
    </ul>
  </div>
</section>
<hr class="w-10/12 lg:w-11/12 mx-auto" />
